import React from "react";
import Figure from "react-bootstrap/Figure";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import acueducto from "../img/SectoresAtendemos/acueducto.jpg";
import agroindustria from "../img/SectoresAtendemos/agroindustria.jpg";
import construccion from "../img/SectoresAtendemos/construccion.jpg";
import industria from "../img/SectoresAtendemos/industria.jpg";
import oyg from "../img/SectoresAtendemos/oyg.jpg";

const sectores = [
  { nombre: "Acueductos", imagen: acueducto, alt: "acueducto" },
  { nombre: "Agroindustria", imagen: agroindustria, alt: "agroindustria" },
  { nombre: "Construcción", imagen: construccion, alt: "construccion" },
  { nombre: "Industria", imagen: industria, alt: "industria" },
  { nombre: "Oil and Gas", imagen: oyg, alt: "oyg" },
];

const SectoresQueAtendemos = () => {
  return (
    <Container className="my-5">
      <h3 className="text-center mb-4 text-danger">Sectores que atendemos</h3>
      <Row className="justify-content-center g-3">
        {sectores.map((sector, index) => (
          <Col key={index} xs={6} sm={4} md={2} className="text-center">
            <Figure>
              <Figure.Image
                src={sector.imagen}
                alt={sector.alt}
                className="img-fluid rounded shadow-sm sector-img"
                style={{ height: "120px", objectFit: "cover", width: "100%" }}
              />
              <Figure.Caption className="mt-2 text-withe fw-semibold sector-caption">
                {sector.nombre}
              </Figure.Caption>
            </Figure>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default SectoresQueAtendemos;
